import { createContext } from 'react';

export const GlobalContext = createContext<{
  userCentricCoreConfigs: Array<CoreConfig>;
  isUserCentricCoreConfigsLoading: boolean;
  webEngageAnonymousId: string | undefined;
  clientSideUserCentricCoreConfigs: Array<CoreConfig>;
}>({
  userCentricCoreConfigs: [],
  isUserCentricCoreConfigsLoading: false,
  webEngageAnonymousId: undefined,
  clientSideUserCentricCoreConfigs: [],
});
